import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface IExportNetworkDiagramConfig {
    modelId: string;
    recurseSectors: boolean;
    centerDiagrams: boolean;
    rootSector: string;
}

@Component
export default class ExportNetworkDiagramDialog extends Vue {

    @Prop()
        value: IExportNetworkDiagramConfig;
        //= {
    //        modelId: "",
    //        recurseSectors: false,
    //        centerDiagrams: false,
    //        rootSector: ""
    //}

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

    onExportClick() {
        this.$emit("dialogClosed", "ok", this.value);
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/export-network-diagram-dialog/export-network-diagram-dialog.ts